/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, TextField, Typography } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { handleChangeAutocomplete } from "../../Utils/Utils";
import { CheckInOrderProps } from "./CheckInMainPage";
import useCustomMemo from "../GenericComponents/useCustomMemo";

export type CheckInPagesProps = {
  checkInOrder: CheckInOrderProps;
  handleChangeCheckInOrder: (checkInOrder: CheckInOrderProps) => void;
};
export default function CheckInTechnician(props: CheckInPagesProps) {
  const { checkInOrder, handleChangeCheckInOrder } = props;
  const cache = useCustomMemo();
  const users = cache.users || [];

  return (
    <div style={{ margin: "10px 0px" }}>
      <Typography
        style={{
          fontSize: 20,
          fontWeight: 400,
          marginBottom: 15,
          textAlign: "center",
        }}
      >
        {Vocabulary.chooseTechnician}
      </Typography>
      <Autocomplete
        size="small"
        id="technician"
        freeSolo={false}
        disablePortal
        getOptionLabel={(option: any) =>
          `${option.username}`
        }
        isOptionEqualToValue={(option: any, value: any) =>
          option._id === value._id
        }
        options={users}
        value={checkInOrder.technician}
        onChange={(event: any, value: any) => {
          handleChangeCheckInOrder(
            handleChangeAutocomplete(event, value, checkInOrder, "technician")
          );
        }}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            name="technician"
            label={Vocabulary.technician}
            variant="outlined"
          />
        )}
      />
    </div>
  );
}
